export const FREE = 'free'
export const STARTER_MONTHLY = 'starter-monthly'
export const STARTER_ANNUAL = 'starter-annual'
export const PRO_MONTHLY = 'pro-monthly'
export const PRO_ANNUAL = 'pro-annual'
